//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
	data() {},

	props: {
		title: {
			default: 'This is a sample post',
		},
		content: {
			default: 'BPB Auto ...',
		},
		email: {
			default: 'info@bpbauto.com.au',
		},
		author: {
			default: 'Anonymous',
		},
		permalink: {
			default: '#',
		},
	},

	computed: {},

	watch: {},

	methods: {},

	components: {},

	created() {},
	mounted() {},
};



// WEBPACK FOOTER //
// ./scripts/vue/PostBanner.vue